﻿import * as React from "react";
import { IGOMAveragesListener } from "../../IGOMAveragesListener";
import { IHashData } from "../../IHashData";
import { IPage } from "../../IPage";
import { MainSite } from "../../MainSite";
import { IGOMAveragesSet } from "../../API/GOMAverages/GOMAveragesSet";
import { GOMTablePageComponent } from "./GOMTablePageComponent";
import * as ReactDOM from "react-dom";

export class GOMTablePage implements IPage, IGOMAveragesListener {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'GOMTable';

    private navBarLink: JQuery;

    public GOMAveragesChanged(latestData: IGOMAveragesSet): void {

        if (!this.$div) {
            return;
        } else {

            //// Update existing component instance
            //if (this.GOMTablePageComponentInstance) {
            //    this.GOMTablePageComponentInstance.updateProps({
            //        mainSite: this.mainSite,
            //        data: latestDataOi
            //    });
            //}

            // Recreate and re-render the whole shebang
            // TODO: Don't do this
            ReactDOM.render(
                React.createElement(
                    GOMTablePageComponent,
                    {
                        mainSite: this.mainSite,
                        data: latestData
                    }
                ),
                this.$div[0]
            );
        }

    }

    public initialize(): void {

        //this.mainSite.liveDataManager.addListener(this);
        this.mainSite.GOMAveragesManager.addListener(this);

        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);

        $('<a></a>')
            .attr('href', '#')
            .click(() => {
                this.mainSite.changePage(this.id);
                return false;
            })
            .text('Table')
            .appendTo(this.navBarLink);
    }

    private container: JQuery = null;

    private $div: JQuery = null;

    private GOMTablePageComponentInstance: any;

    public handleHashChange(hashData: IHashData): boolean {

        console.log('this.mainSite: ', this.mainSite)
        console.log('this.mainSite.liveDataManager: ', this.mainSite.liveDataManager)
        console.log('this.mainSite.liveDataManager.latestData: ', this.mainSite.liveDataManager.latestData)

        //: TODO: this is initial auth check, but it will need to be improved/adapted in future!
        if (this.mainSite.selectedRegion.Id != "GOM") {
            this.navBarLink.hide(); //: ugly, should be improved!
        } else {
            this.navBarLink.show();
        }

        if ((hashData.Page === this.id) && (this.mainSite.selectedRegion.Id == "GOM")) {

            this.navBarLink.addClass('active');

            if (!this.container) {

                this.container = $('<div class="container-fluid" liveData-wrapper-for="GOMTablePage"></div>').appendTo('body');

                this.$div = $('<div class="col-sm-12">').appendTo($('<div class="row">').appendTo(this.container));

                // Not working
                //const root = ReactDOM.createRoot
                //this.GOMTablePageComponent = ReactDOM.render(

                // Render pageComponent
                ReactDOM.render(
                    React.createElement(
                        GOMTablePageComponent,
                        {
                            mainSite: this.mainSite,
                            data: this.mainSite.GOMAveragesManager.latestData?.Stations ? this.mainSite.GOMAveragesManager.latestData :  null
                        }
                    ),
                    this.$div[0]
                );

                //// Create initial component instance
                //ReactDOM.render(
                //    React.createElement(
                //        GOMTable.GOMTablePageComponent,
                //        {
                //            ref: (instance) => {
                //                this.GOMTablePageComponentInstance = instance;
                //            },
                //            mainSite: this.mainSite,
                //            data: null
                //        }
                //    ),
                //    this.$div[0]
                //);

            }

            return true;

        } else {

            this.navBarLink.removeClass('active');

            if (this.container) {
                this.container.remove();
                this.container = null;
            }

            return false;
        }
    }
}